const Container = ({ children }) => {
  return (
    <div className="mx-auto w-full max-w-[1320px] px-4 2xl:px-0 xl:px-10">
      {children}
    </div>
  );
};

export default Container;
